import { createContext, useContext } from 'react';

const MediaOwnerContext = createContext<number>(0);

export const MediaOwnerProvider = MediaOwnerContext.Provider;
export const useMediaOwner = (): number => useContext(MediaOwnerContext);
